import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router-dom';
import { stopPropagation } from '@services/stopPropagation';
import { TooltipWrapper, TooltipItem, Icon, Button } from '@atoms';

const wrapperStyles = {
  display: 'block',
  position: 'relative',
};
const tooltipWrapperStyles = {
  position: 'absolute',
  left: '-176px',
  top: '10px',
};

class ConferenceDashboardTooltipMenu extends PureComponent {
  static propTypes = {
    isConferenceDone: PropTypes.bool.isRequired,
    canRequestHumanTranscript: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    requestHumanTranscript: PropTypes.func.isRequired,
    isConferenceDeleted: PropTypes.bool,
  };

  state = {
    tooltipOpen: false,
  };

  toggleTooltip = (e) => {
    stopPropagation(e);
    const { tooltipOpen } = this.state;
    this.setState({ tooltipOpen: !tooltipOpen });
  };

  handleClickOutside = () => this.setState({ tooltipOpen: false });
  requestHumanTranscript = (e) => {
    const { canRequestHumanTranscript, requestHumanTranscript, id } = this.props;
    stopPropagation(e);
    if (canRequestHumanTranscript) {
      requestHumanTranscript(id);
    }
  };

  render() {
    const {
      isConferenceDone,
      canRequestHumanTranscript,
      id,
      isConferenceDeleted,
    } = this.props;
    const { tooltipOpen } = this.state;

    return (
      <span style={wrapperStyles} className="edit">
        <Button invisible onClick={this.toggleTooltip}>
          <Icon active={tooltipOpen} name="pencilGrey" />
        </Button>
        {tooltipOpen && (
          <TooltipWrapper style={tooltipWrapperStyles}>
            <TooltipItem>
              {isConferenceDone || isConferenceDeleted ? (
                <Link to={`/conference/view/${id}`} onClick={stopPropagation}>
                  View
                </Link>
              ) : (
                <Link to={`/conference/edit/${id}`} onClick={stopPropagation}>
                  Edit
                </Link>
              )}
            </TooltipItem>
            {canRequestHumanTranscript && (
              <TooltipItem>
                <Button invisible onClick={this.requestHumanTranscript}>
                  Request Manual Transcript
                </Button>
              </TooltipItem>
            )}
          </TooltipWrapper>
        )}
      </span>
    );
  }
}

export default onClickOutside(ConferenceDashboardTooltipMenu);



// WEBPACK FOOTER //
// ./components/molecules/ConferenceDashboardTooltipMenu.js